import { getLocale } from "../runtime";

const sv_easteregg2 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Kom ihåg att dricka vatten medan du surfar. Små stunder av egenvård förbättrar ditt dagliga välbefinnande.`
};

const easteregg2 = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_easteregg2(inputs)
	return "easterEgg2";
};

export { easteregg2 as "easterEgg2" };